module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/1/3-828763dcbd13e82e4a2ce53f769ff39b.jpg";